import commonMixin from '../../../mixins/_common';
import modalMixin from '../../../mixins/_modal';
import flashMessageMixin from '../../../mixins/_flash_messages';
import loop from '../../_loop-component';
import showStaticHtml from '../../_show_static_html';

/**
 * パーツプレビューコンポーネント
 */
export default {
    name: 'PartsPreview',
    template: '#parts_preview_template',
    data() {
        return {
            // 選択状態パーツインデックスリスト
            selected_parts_index_list: [],
            // 全体のデザイン設定もコピーするか
            is_copy_all: false
        };
    },
    props: {
        // ページデザインデータ
        page_template: {
            type: Object,
            required: true,
        },
    },
    computed: {
        // パーツ数
        parts_num: function () {
            return (Object.keys(this.page_template).length) ? this.page_template.parts.length : 0;
        },
        // 選択中のパーツ数
        selected_parts_num: function () {
            return this.selected_parts_index_list.length;
        },
    },
    mixins: [
        commonMixin,
        modalMixin,
        flashMessageMixin,
    ],
    components: {
        // ループコンポーネント
        'loop': loop,
        // 静的HTMLを表示するコンポーネント
        'show-static-html': showStaticHtml
    },
    emits: ['selected-parts'],
    methods: {
        // 初期化処理
        opening: function () {
            this.selected_parts_index_list = [];
        },
        // 全てのパーツを選択状態にする
        selectAllParts: function () {
            this.selected_parts_index_list = Array(this.parts_num).fill(null).map( ( _, index) => index);
        },
        // 対象パーツの選択/非選択を切り替える
        selectPart: function (index) {
            const partIndex = this.selected_parts_index_list.indexOf(index);
            // 対象パーツは選択状態か
            if (partIndex > -1) {
                this.selected_parts_index_list.splice(partIndex, 1);
            } else {
                this.selected_parts_index_list.push(index);
            }
        },
        // パーツは選択状態か
        isPartSelected: function (index) {
            return this.selected_parts_index_list.includes(index);
        },
        // 選択されたパーツを親へ通知する
        emitSelectedParts: function () {
            this.$emit('selected-parts', this.selected_parts_index_list, this.is_copy_all);
            this.close();
        }
    },
};
